import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './ResetPassword.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const resetCode = searchParams.get('code');

  useEffect(() => {
    if (!resetCode) {
      setError('Reset code is missing from URL');
    }
  }, [resetCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    setIsLoading(true);
    
    try {
      const response = await fetch('https://yetdekmxmbqdqescdgbc.supabase.co/functions/v1/reset-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          resetCode,
          newPassword,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to reset password');
      }

      setIsSubmitted(true);
    } catch (err) {
      setError(err.message || 'Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="reset-password-page">
        <div className="container">
          <div className="reset-password-card">
            <div className="success-message">
              <div className="success-icon">
                <div className="checkmark"></div>
              </div>
              <h2>Password Reset Successful</h2>
              <p>Your password has been successfully reset.</p>
              <div className="form-actions">
                <Link to="/" className="back-link">Back to Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <div className="container">
        <div className="reset-password-card">
          <div className="card-header">
            <Link to="/" className="logo">
              <h1>Heni</h1>
            </Link>
          </div>
          
          <div className="card-content">
            <h2>Reset your password</h2>
            <p className="description">
              Enter your new password below.
            </p>
            
            {error && <div className="error-message">{error}</div>}
            
            <form onSubmit={handleSubmit} className="reset-form">
              <div className="form-group">
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                  disabled={isLoading}
                  className={isLoading ? 'loading' : ''}
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                  disabled={isLoading}
                  className={isLoading ? 'loading' : ''}
                />
              </div>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={isLoading || !newPassword || !confirmPassword}
              >
                {isLoading ? (
                  <div className="loading-content">
                    <div className="spinner"></div>
                    Changing password...
                  </div>
                ) : (
                  'Change password'
                )}
              </button>
            </form>
            
            <div className="form-footer">
              <Link to="/" className="back-link">
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword; 